//css
import '../../css/tachyons.css';
import '../../css/styles.css';
import '../../css/semantic.css';
//js
//import jquery-mm from './jquery-mega-menu';
import navmenu from './navmenu';
import contactbox from './contact_box';

contactbox.generateContactBox();